const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function isValidVoucherEmail(email) {
  return EMAIL_RE.test(String(email || "").trim());
}

export function normalizeVoucherRecipients(raw) {
  const seen = new Set();
  const out = [];
  for (const row of Array.isArray(raw) ? raw : []) {
    const email = String(row?.email || row || "").trim().toLowerCase();
    if (!email || !isValidVoucherEmail(email) || seen.has(email)) continue;
    seen.add(email);
    out.push({
      email,
      name: String(row?.name || row?.label || "").trim(),
    });
  }
  return out;
}

export function emptyVoucherRecipientRow() {
  return { email: "", name: "" };
}

/**
 * Recipients for hotel-voucher send.
 * Overlay list is SSOT for ops-created hotels; catalog hotels use overlay sidecar.
 * send-hotel-reservation-email should pass this array as `voucher_recipients`.
 */
export function resolveCampaignVoucherRecipients(hotelCode, overlayHotel, sidecarMap) {
  const fromHotel = normalizeVoucherRecipients(overlayHotel?.voucherRecipients);
  if (fromHotel.length) return fromHotel;
  const code = String(hotelCode || overlayHotel?.hotelCode || "").trim();
  if (!code) return [];
  return normalizeVoucherRecipients(sidecarMap?.[code]);
}
